import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 18.5001V5.50006C3 5.13339 3.15 4.85406 3.45 4.66206C3.75 4.47072 4.06667 4.44172 4.4 4.57506L19.8 11.0751C20.2167 11.2584 20.425 11.5667 20.425 12.0001C20.425 12.4334 20.2167 12.7417 19.8 12.9251L4.4 19.4251C4.06667 19.5584 3.75 19.5291 3.45 19.3371C3.15 19.1457 3 18.8667 3 18.5001ZM5 17.0001L16.85 12.0001L5 7.00006V10.5001L11 12.0001L5 13.5001V17.0001ZM5 7.00006V10.5001V13.5001V17.0001V7.00006Z",
		fill: "currentColor"
	})
});
export default SvgSend;
